import { RouterProvider } from 'react-router-dom';
import { router } from './router';

/**
 * App - root component.
 *
 * Mounts the react-router-dom `<RouterProvider>` with the AppShell layout
 * and the eight tab routes (PROD-578). The Zustand stores (mode, tenant,
 * user) are read inside AppShell + ModeBadge + TenantFooterPlaceholder.
 *
 * The previous PR #1 placeholder homepage is superseded by the routed
 * AppShell; the verification flow is now: visit `/`, see TopBar + 8 tabs +
 * Pathway Studio placeholder.
 */
function App() {
  return <RouterProvider router={router} />;
}

export default App;
